/* tslint:disable */

declare var Object: any;
export interface SampleInterface {
  "name"?: string;
  "id"?: number;
}

export class Sample implements SampleInterface {
  "name": string;
  "id": number;
  constructor(data?: SampleInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Sample`.
   */
  public static getModelName() {
    return "Sample";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Sample for dynamic purposes.
  **/
  public static factory(data: SampleInterface): Sample{
    return new Sample(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Sample',
      plural: 'Samples',
      path: 'Samples',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/services/sdk/models/Sample.ts